import React from "react";

const CustomPagination = React.memo(
  ({ lastPage, currentPage, onClick, entries, limit = 10 }) => {
    const renderPaginationButtons = () => {
      lastPage = Number(lastPage);
      currentPage = Number(currentPage);

      const pagination = [];

      if (lastPage > 1) {
        if (currentPage === 2) {
          if (currentPage !== 1 && currentPage !== lastPage) {
            pagination.push(currentPage);
          }
          if (currentPage + 1 < lastPage) {
            pagination.push(currentPage + 1);
          }
          if (currentPage + 2 < lastPage) {
            pagination.push(currentPage + 2);
          }
        }
        if (currentPage > 1 && currentPage !== 2 && currentPage !== lastPage) {
          if (currentPage - 1 > 1) {
            pagination.push(currentPage - 1);
          }
          if (currentPage !== 1 && currentPage !== lastPage) {
            pagination.push(currentPage);
          }
          if (currentPage + 1 < lastPage) {
            pagination.push(currentPage + 1);
          }
        }
        if (currentPage === 1) {
          if (currentPage + 1 < lastPage) {
            pagination.push(currentPage + 1);
          }
          if (currentPage + 2 < lastPage) {
            pagination.push(currentPage + 2);
          }
          if (currentPage + 3 < lastPage) {
            pagination.push(currentPage + 3);
          }
        }
        if (currentPage === lastPage && lastPage !== 2) {
          if (currentPage - 3 > 1) {
            pagination.push(currentPage - 3);
          }
          if (currentPage - 2 > 1) {
            pagination.push(currentPage - 2);
          }
          if (currentPage - 1 > 1) {
            pagination.push(currentPage - 1);
          }
        }
      }
      const pagesArray = pagination.map((pg, index) => (
        <button
          key={pg}
          className={`btn ${currentPage === pg ? "btn-green" : "btn-white"}`}
          style={{
            // border: "1px solid #cbcbcb",
            borderRadius: 0,
            borderLeft: "none",
            boxShadow: "none",
          }}
          onClick={() => onClick(+pg)}
        >
          {pg}
        </button>
      ));

      pagesArray.unshift(
        <button
          key="initial"
          className={`btn ${currentPage === 1 ? "btn-green" : "btn-white"}`}
          style={{
            // border: "1px solid #cbcbcb",
            borderRadius: 0,
            boxShadow: "none",
          }}
          onClick={() => onClick(1)}
        >
          1
        </button>
      );
      if (lastPage !== 1 && currentPage <= lastPage) {
        pagesArray.push(
          <button
            key="last-page"
            className={`btn ${
              currentPage === lastPage ? "btn-green" : "btn-white"
            }`}
            style={{
              // border: "1px solid #cbcbcb",
              borderRadius: 0,
              borderLeft: 0,
              boxShadow: "none",
            }}
            onClick={() => onClick(+lastPage)}
          >
            {lastPage}
          </button>
        );
      }
      pagesArray.unshift(
        <button
          key="prev"
          className="btn"
          style={{
            // border: "1px solid #cbcbcb",
            borderRight: "none",
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          }}
          disabled={currentPage === 1}
          onClick={() => (currentPage === 1 ? null : onClick(currentPage - 1))}
        >
          Previous
        </button>
      );
      pagesArray.push(
        <button
          key="next"
          className="btn"
          disabled={currentPage === lastPage}
          // style={{border:'1px solid #cbcbcb',borderRight:'1px solid #cbcbcb',borderLeft:'none',borderTopLeftRadius:0,borderBottomLeftRadius:0}}
          onClick={
            currentPage === lastPage ? null : () => onClick(currentPage + 1)
          }
        >
          Next
        </button>
      );
      return pagesArray;
    };

    return (
      <div className="row custom-pagination">
        <div className="col-xs-12 col-md-6">
          {entries === 0 ? (
            <p />
          ) : (
            <p className="mb-0">{`Showing ${
              currentPage * limit - limit > 0 ? currentPage * limit - limit : 1
            } to ${
              currentPage === lastPage ? entries : currentPage * limit
            } of ${entries} entries`}</p>
          )}
        </div>
        <div className="col-xs-12 col-md-6 custom-pagination-pages">
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {renderPaginationButtons()}
          </div>
        </div>
      </div>
    );
  }
);

export default CustomPagination;

// function CustomPagination({ handleChange, lastPage, pagination }) {
//   const getPages = () => {
//     if (pagination.page === 1) {
//       if (lastPage > 4) {
//         return [
//           { pageno: 1, clickable: true },
//           { pageno: 2, clickable: true },
//           { pageno: 3, clickable: true },
//           { pageno: "...", clickable: false },
//           { pageno: lastPage, clickable: true },
//         ];
//       } else if (lastPage <= 4) {
//         return Array.from({ length: lastPage }, (v, k) => ({
//           pageno: k + 1,
//           clickable: true,
//         }));
//       }
//     } else if (pagination.page === 2) {
//       if (lastPage > 5) {
//         return [
//           { pageno: 1, clickable: true },
//           { pageno: 2, clickable: true },
//           { pageno: 3, clickable: true },
//           { pageno: 4, clickable: true },
//           { pageno: "...", clickable: false },
//           { pageno: lastPage, clickable: true },
//         ];
//       } else if (lastPage <= 5) {
//         return Array.from({ length: lastPage }, (v, k) => ({
//           pageno: k + 1,
//           clickable: true,
//         }));
//       }
//     } else if (pagination.page === 3) {
//       if (lastPage > 6) {
//         return [
//           { pageno: 1, clickable: true },
//           { pageno: 2, clickable: true },
//           { pageno: 3, clickable: true },
//           { pageno: 4, clickable: true },
//           { pageno: 5, clickable: true },
//           { pageno: "...", clickable: false },
//           { pageno: lastPage, clickable: true },
//         ];
//       } else if (lastPage <= 6) {
//         return Array.from({ length: lastPage }, (v, k) => ({
//           pageno: k + 1,
//           clickable: true,
//         }));
//       }
//     } else if (pagination.page === lastPage) {
//       if (lastPage > 5) {
//         return [
//           { pageno: 1, clickable: true },
//           { pageno: "...", clickable: false },
//           { pageno: lastPage - 2, clickable: true },
//           { pageno: lastPage - 1, clickable: true },
//           { pageno: lastPage, clickable: true },
//         ];
//       } else {
//         return Array.from({ length: lastPage }, (v, k) => ({
//           pageno: k + 1,
//           clickable: true,
//         }));
//       }
//     } else if (pagination.page === lastPage - 1) {
//       if (lastPage > 5) {
//         return [
//           { pageno: 1, clickable: true },
//           { pageno: "...", clickable: false },
//           { pageno: lastPage - 3, clickable: true },
//           { pageno: lastPage - 2, clickable: true },
//           { pageno: lastPage - 1, clickable: true },
//           { pageno: lastPage, clickable: true },
//         ];
//       } else {
//         return Array.from({ length: lastPage }, (v, k) => ({
//           pageno: k + 1,
//           clickable: true,
//         }));
//       }
//     } else if (pagination.page === lastPage - 2) {
//       if (lastPage > 6) {
//         return [
//           { pageno: 1, clickable: true },
//           { pageno: "...", clickable: false },
//           { pageno: lastPage - 4, clickable: true },
//           { pageno: lastPage - 3, clickable: true },
//           { pageno: lastPage - 2, clickable: true },
//           { pageno: lastPage - 1, clickable: true },
//           { pageno: lastPage, clickable: true },
//         ];
//       } else {
//         return Array.from({ length: lastPage }, (v, k) => ({
//           pageno: k + 1,
//           clickable: true,
//         }));
//       }
//     } else {
//       return [
//         { pageno: 1, clickable: true },
//         { pageno: "...", clickable: false },
//         { pageno: pagination.page - 2, clickable: true },
//         { pageno: pagination.page - 1, clickable: true },
//         { pageno: pagination.page, clickable: true },
//         { pageno: pagination.page + 1, clickable: true },
//         { pageno: pagination.page + 2, clickable: true },
//         { pageno: "...", clickable: false },
//         { pageno: lastPage, clickable: true },
//       ];
//     }
//   };

//   return (
//     <div className="d-flex justify-content-center m-3">
//       <Button
//         variant="button-outlined"
//         disabled={!pagination.prebtn}
//         onClick={() => handleChange(pagination.page - 1)}
//       >
//         &lt;
//       </Button>
//       {getPages().map((page, index) => (
//         <div key={index}>
//           {page.clickable ? (
//             <Button
//               variant="button-outlined"
//               style={{
//                 backgroundColor:
//                   pagination.page === page.pageno ? "#3f51b5" : "",
//                 color: pagination.page === page.pageno ? "#fff" : "inherit",
//                 borderRadius: "5rem",
//                 margin: "0 0.3rem",
//               }}
//               onClick={() => handleChange(page.pageno)}
//             >
//               {page.pageno}
//             </Button>
//           ) : (
//             <div style={{ position: "relative", top: "2px" }}>
//               {page.pageno}
//             </div>
//           )}
//         </div>
//       ))}
//       <Button
//         variant="button-outlined"
//         disabled={!pagination.nextbtn}
//         onClick={() => handleChange(pagination.page + 1)}
//       >
//         &gt;
//       </Button>
//     </div>
//   );
// }

// export default CustomPagination;
